import type { ReactNode } from 'react';

import FOSSALogoWithCatWhite from '../../generic/FOSSAInlineSVG/FOSSALogoWithCatWhite';
import Link from '../../generic/Link/Link';

import styles from './AuthLayout.module.less';

export type AuthLayoutProps = {
  children: ReactNode;
};

/**
 * Full-page shell for the auth pages: a centered column on the brand-black background, with the FOSSA logo above the
 * content. Shared by the login, register, password-reset, and onboarding pages.
 */
const AuthLayout = ({ children }: AuthLayoutProps) => (
  <div className={styles.page}>
    <div className={styles.logo}>
      <Link to="https://fossa.com/" openInNewTab>
        <FOSSALogoWithCatWhite width={150} />
      </Link>
    </div>
    {children}
  </div>
);

export default AuthLayout;
